import { type FC, type HTMLAttributes, type JSX } from 'react';

import styles from './SeriaPlusSection.css';

type SeriaPlusSectionProps = Omit<HTMLAttributes<HTMLElement>, 'id' | 'className'> & {
  children: JSX.Element;
};

export const SeriaPlusSection: FC<SeriaPlusSectionProps> = props => {
  const { children, ...restProps } = props;

  return (
    <section id="seria-plus" {...restProps} className={styles['section']}>
      {children}
    </section>
  );
};
